<template>
<div id="edit-puzzle" v-if="id">
  <h2>Edit
    <router-link
      :to="{
        name: 'puzzle',
        params: { puzzleId: puzzleId }
      }"
    >
      Puzzle #{{ puzzleId }}
    </router-link>
  </h2>

  <puzzle-nav
    :puzzleId="puzzleId"
  ></puzzle-nav>

  <puzzle-form
    :puzzleId="puzzleId"
    puzzleUploadRequired="false"
  ></puzzle-form>

</div>
</template>

<script>
import PuzzleForm from '@/components/PuzzleForm'
import PuzzleNav from '@/components/PuzzleNav'

import PuzzleStore from '@/stores/PuzzleStore'

export default {
  data () {
    return PuzzleStore.state
  },

  computed: {
    puzzleUrl () {
      return '/puzzles/' + this.puzzleId
    }
  },

  props: ['puzzleId'],

  components: {
    'PuzzleForm': PuzzleForm,
    'PuzzleNav': PuzzleNav
  },

  created () {
    this.get()
  },

  methods: {
    get () {
      this.$http.get(this.apiUrl(this.puzzleUrl, true), {
        headers: {
          'Accept': 'application/json'
        }
      }).then((resp) => {
        this.processSuccess(resp, PuzzleStore)
        this.apiGet(this.puzzleUrl + '/attachments', null, true).then((resp) => {
          this.attachments = resp
        })

        this.tags = this.tags.map((tag) => {
          tag.attributes.id = tag.id
          return tag.attributes
        })
      }, this.$root.processErrors)
    }
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PuzzleEdit.vue